import { gql } from "@apollo/client";

export const GET_HONORARIO_PROFESIONAL = gql`
  query getHonorarioProfesional($filter: HonorarioProfesionalFilterInput!) {
    honorarioProfesional(filter: $filter) {
      idHonorarioProfesional
      descripcion
      valor
      valorVirtual
      cambioSonda
      capacitacion
      emergencia
      extraDuracion
      valorExtra
    }
  }
`;